module.exports = __webpack_public_path__ + "static/media/new-img7.aa640711.png";